module.exports = __webpack_public_path__ + "static/media/Chair_Character_02.42f10f2d.jpg";